import { Grid } from '@mui/system';
import MainCard from '../../components/MainCard';
import DynamicForm from '../../components/Forms/DynamicForm';
import { createUserFormConfig } from '../../utils/AdminFeatures/formConfig';

export default function UserCreate() {
  return (
     <MainCard >
      {/* <Typography variant="body2">
        Lorem ipsum dolor sit amen, consenter nipissing eli, sed do elusion tempos incident ut laborers et doolie magna alissa. Ut enif ad
        minim venice, quin nostrum exercitation illampu laborings nisi ut liquid ex ea commons construal. Duos aube grue dolor in
        reprehended in voltage veil esse colum doolie eu fujian bulla parian. Exceptive sin ocean cuspidate non president, sunk in culpa qui
        officiate descent molls anim id est labours.
      </Typography> */}
       

      <Grid size={{ xs: 12, md: 7, lg: 8 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid>
            {/* <Typography variant="h5">{typo}</Typography> */}
          </Grid>
          <Grid />
        </Grid>
        <MainCard sx={{ mt: 2 }} content={false}>
            <DynamicForm config={createUserFormConfig}/>
        </MainCard>
      </Grid>
    </MainCard>
  )
}